import { render, staticRenderFns } from "./BioUpgrade.vue?vue&type=template&id=11465b65&scoped=true&"
import script from "./BioUpgrade.vue?vue&type=script&lang=js&"
export * from "./BioUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./BioUpgrade.vue?vue&type=style&index=0&id=11465b65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11465b65",
  null
  
)

export default component.exports